import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Button, Form, Table, Spinner } from "react-bootstrap";
import { FaPlus, FaTrash } from 'react-icons/fa';
import Select from 'react-select';
import { getSESProducts, setSIVProductInventoryTransaction } from '../../actions';
import { getTranslate, LANGUAGE_KEYS } from '../../utils/language';
import IframeModal from '../../components/IframeModal/IframeModal';

class ImportExport extends Component {
  state = {
    loading: false,
    type: window.location.pathname.includes('/import') ? 'IMPORT' : 'EXPORT',
    warehouse: '',
    transaction_date: new Date().toISOString().split('T')[0], // Default to today
    items: [
      {
        product_code: '',
        quantity: 0
      }
    ],
    note: '',
    saving: false,
    showHistoryModal: false,
  };

  componentDidMount() {
    // Load products with default pagination
    this.props.getSESProducts({
      currentPage: 1,
      itemsPerPage: 9999,
      sortBy: 'product_code',
      sortOrder: 1
    });
  }

  handleWarehouseChange = (e) => {
    this.setState({ warehouse: e.target.value });
  };

  handleTransactionDateChange = (e) => {
    this.setState({ transaction_date: e.target.value });
  };

  handleAddItem = () => {
    this.setState(prevState => ({
      items: [...prevState.items, { product_code: '', quantity: 0 }]
    }));
  };

  handleRemoveItem = (index) => {
    this.setState(prevState => ({
      items: prevState.items.filter((_, i) => i !== index)
    }));
  };

  handleItemChange = (index, field, value) => {
    this.setState(prevState => ({
      items: prevState.items.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    }));
  };

  handleNoteChange = (e) => {
    this.setState({ note: e.target.value });
  };

  handleSubmit = () => {
    const { type, warehouse, transaction_date, items, note } = this.state;
    const { products } = this.props;

    // Validate
    if (!warehouse) {
      alert(getTranslate(LANGUAGE_KEYS.TEXT_PLEASE_SELECT_WAREHOUSE));
      return;
    }

    if (!transaction_date) {
      alert('Vui lòng chọn ngày giao dịch');
      return;
    }

    if (items.some(item => !item.product_code)) {
      alert(getTranslate(LANGUAGE_KEYS.TEXT_PLEASE_FILL_ALL));
      return;
    }

    this.setState({ saving: true });

    // Prepare data for API
    const transaction = {
      type,
      partner_id: warehouse,
      transaction_date,
      staff_note: note,
      items: items.map(item => {
        const product = products.find(p => p.product_code === item.product_code);
        const current_qty = product ? product.current_qty || 0 : 0;
        const quantity_change = type === 'IMPORT' ? item.quantity : -item.quantity;
        const quantity = current_qty + quantity_change;

        return {
          product_code: item.product_code,
          quantity_change,
          quantity,
          warehouse_id: 1,
          warehouse_cell_code: product ? product.current_cell_code || '' : ''
        };
      })
    };

    console.log("transaction", transaction);

    this.props.setSIVProductInventoryTransaction(transaction)
      .then(() => {
        alert(getTranslate(LANGUAGE_KEYS.TEXT_SUCCESSFULLY_SAVED));
        this.setState({
          items: [{ product_code: '', quantity: 0 }],
          note: '',
          saving: false
        });
        this.props.history.push('/admin/fulfill/transactions');
      })
      .catch(error => {
        console.error('Error saving transaction:', error);
        alert(getTranslate(LANGUAGE_KEYS.TEXT_FAILED_SAVE));
        this.setState({ saving: false });
      });
  };

  handleOpenHistoryModal = () => {
    this.setState({ showHistoryModal: true });
  };

  handleCloseHistoryModal = () => {
    this.setState({ showHistoryModal: false });
  };

  render() {
    const { type, warehouse, items, note, saving } = this.state;
    const { products } = this.props;

    const productOptions = products ? products.map(product => ({
      value: product.product_code,
      label: `${product.product_code} - ${product.product_name}`
    })) : [];

    // Calculate totals
    const totalQuantity = items.reduce((sum, item) => sum + (parseInt(item.quantity) || 0), 0);
    const totalItems = items.filter(item => item.product_code).length;

    const warehouseOptions = type === 'IMPORT'
      ? [
        { value: 'RESIN_HOAI_DUC', label: 'RESIN HOÀI ĐỨC' },
        { value: 'BREAKWOODEN', label: 'BREAKWOODEN' },
        { value: 'OTHER', label: 'OTHER' }
      ]
      : [
        { value: 'SAIGONBAY', label: 'SAIGONBAY' },
        { value: 'VIETTEL_POST', label: 'VIETTEL POST' },
        { value: 'OTHER', label: 'OTHER' }
      ];

    return (
      <Container fluid>
        <h2 className="text-center mb-4">{type === 'IMPORT' ? getTranslate(LANGUAGE_KEYS.TEXT_IMPORT) : getTranslate(LANGUAGE_KEYS.TEXT_EXPORT)} {getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT)}</h2>

        <Row className="mb-4 align-items-end">
          <Col md={4}>
            <Form.Group>
              <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_PARTNER)}</Form.Label>
              <Form.Select
                value={warehouse}
                onChange={this.handleWarehouseChange}
              >
                <option value="">{getTranslate(LANGUAGE_KEYS.TEXT_SELECT_PARTNER)}</option>
                {warehouseOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Ngày giao dịch</Form.Label>
              <Form.Control
                type="date"
                value={this.state.transaction_date}
                onChange={this.handleTransactionDateChange}
              />
            </Form.Group>
          </Col>
          <Col md={4} className="text-end">
            <Button
              variant="info"
              onClick={this.handleOpenHistoryModal}
            >
              {getTranslate(LANGUAGE_KEYS.TEXT_HISTORY)} {type === 'IMPORT' ? getTranslate(LANGUAGE_KEYS.TEXT_IMPORT) : getTranslate(LANGUAGE_KEYS.TEXT_EXPORT)}
            </Button>
          </Col>
        </Row>

        <Table striped bordered hover>
          <thead>
            <tr>
              <th>{getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_CODE)}</th>
              <th>{getTranslate(LANGUAGE_KEYS.TEXT_QUANTITY)}</th>
              <th>{getTranslate(LANGUAGE_KEYS.TEXT_ACTION)}</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index}>
                <td>
                  <Select
                    value={productOptions.find(option => option.value === item.product_code)}
                    onChange={(option) => this.handleItemChange(index, 'product_code', option ? option.value : '')}
                    options={productOptions}
                    isClearable
                    placeholder={getTranslate(LANGUAGE_KEYS.TEXT_SELECT_PRODUCT)}
                    noOptionsMessage={() => getTranslate(LANGUAGE_KEYS.TEXT_NO_ORDERS_FOUND)}
                  />
                </td>
                <td>
                  <Form.Control
                    type="number"
                    value={item.quantity}
                    onChange={(e) => this.handleItemChange(index, 'quantity', parseInt(e.target.value) || 0)}
                  />
                </td>
                <td>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => this.handleRemoveItem(index)}
                    disabled={items.length === 1}
                    style={{
                      color: 'black',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      backgroundColor: '#ffcaca',
                      borderColor: '#ffcaca'
                    }}
                  >
                    <FaTrash style={{ color: 'black' }} /> {getTranslate(LANGUAGE_KEYS.TEXT_REMOVE)}
                  </Button>
                </td>
              </tr>
            ))}
            <tr className="table-info">
              <td colSpan="1" className="text-end fw-bold">
                {getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_ITEMS)}: {totalItems}
              </td>
              <td colSpan="2" className="text-end fw-bold">
                {getTranslate(LANGUAGE_KEYS.TEXT_TOTAL_QUANTITY)}: {totalQuantity}
              </td>
            </tr>
          </tbody>
        </Table>

        <Row className="mb-4">
          <Col>
            <Button
              variant="primary"
              onClick={this.handleAddItem}
            >
              <FaPlus /> {getTranslate(LANGUAGE_KEYS.TEXT_ADD_ITEM)}
            </Button>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col>
            <Form.Group>
              <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_NOTE)}</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={note}
                onChange={this.handleNoteChange}
                placeholder={getTranslate(LANGUAGE_KEYS.TEXT_ENTER_NOTE)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col className="text-end">
            <Button
              variant="success"
              onClick={this.handleSubmit}
              disabled={saving}
            >
              {saving ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  {getTranslate(LANGUAGE_KEYS.TEXT_SAVING)}
                </>
              ) : (
                getTranslate(LANGUAGE_KEYS.TEXT_SAVE)
              )}
            </Button>
          </Col>
        </Row>

        <IframeModal
          show={this.state.showHistoryModal}
          onHide={this.handleCloseHistoryModal}
          url="/admin/fulfill/transactions?hide_sidebar=true"
          title={`${getTranslate(LANGUAGE_KEYS.TEXT_HISTORY)} ${type === 'IMPORT' ? getTranslate(LANGUAGE_KEYS.TEXT_IMPORT) : getTranslate(LANGUAGE_KEYS.TEXT_EXPORT)}`}
        />
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  products: state.sesProductReducer.products
});

export default connect(mapStateToProps, {
  getSESProducts,
  setSIVProductInventoryTransaction
})(ImportExport); 